
import React, { useCallback, useEffect } from 'react'
import { hooks } from '@front/volcanion'

const withContainer = Component => () => {
  const { list_id } = hooks.useParams()
  const navigate = hooks.useNavigate()

  const [tasks] = hooks.useModelSearch('task', 'get', {
    search_id: 'list_tasks',
    initial_filter: { name: 'import' },
    watch_type: 'result'
  })

  hooks.useModelSearchCount('order', 'get', {
    search_id: 'list_orders_created',
    initial_filter: { list: list_id, status: { '!': ['canceled'] } },
    watch_type: 'result',
  })

  const task = _.find(tasks, (t) => _.get(t, 'input.list') === list_id)
  const onRowClick = useCallback((order_id) => navigate(`/order/${order_id}`), [navigate])

  const isComplete = task?.status === 'complete'

  useEffect(() => {
    if (isComplete && (!_.isEmpty(task?.result?.fails) || !_.isEmpty(task?.result?.incorrects)))
      console.warn('import_order_report', { fails: task?.result?.fails, incorrects: task?.result?.incorrects })
  }, [isComplete])

  const mergedProps = {
    list_id,
    task,
    onRowClick
  }

  return (
    <Component {...mergedProps} />
  )
}

export default withContainer
